/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 通讯状态
 */
let EnmuCommunicationStatus = {
	Online: 					new EnumItem('联网', 1),
	OffLine: 					new EnumItem('断线', 3),
	...enumMixn
}
export default EnmuCommunicationStatus
